import ABApiRoutes from '@/api/ABApiRoutes';
import { IApiCalendarDoor } from '@/common/interfaces/api.interface';
import CookieHelper from '@/helpers/CookieHelper';

export default class ABApiService {
  public async getDoorById(id: number): Promise<IApiCalendarDoor> {
    return ABApiRoutes.getDoorById.fetch({
      data: { language: CookieHelper.getLanguage() },
      params: { id },
    });
  }
}
